import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Login from './Login';
import RequestPasswordReset from '../../views/system/RequestPasswordReset';
import ResetPassword from '../../views/system/ResetPassword';
import App from '../../views/system/App';
import ComponentTests from '../../views/system/ComponentTests';

const RouteSwitch = () => {
  return (
    <Switch>
      <Route exact path="/Login" component={Login} />
      <Route path="/RequestPasswordReset" component={RequestPasswordReset} />
      <Route exact path="/ResetPassword/:token" component={ResetPassword} />
      <Route exact path="/ResetPassword/:token/:username" component={ResetPassword} />
      <Route path="/Components/:id" component={ComponentTests} />
      <Route path="/" component={App} />
    </Switch>
  );
};

export default RouteSwitch;
